const YearOfEducEnum = Object.freeze([{
    name: "Excellent",
    code: "EXC",
}, {
    name: "Verry Good",
    code: "VGOO",
}, {
    name: "Good",
    code: "GOO",
}, {
    name: "Poor",
    code: "POO",
}]);

export default YearOfEducEnum;